import { useGameStore } from '../state/useGameStore';

export function resolveHitIndicatorArc(hitAngleRad: number, cameraYaw: number): number {
  return Math.round(((hitAngleRad - cameraYaw + Math.PI * 2) % (Math.PI * 2)) / (Math.PI / 2)) % 4;
}

const ARC_TRANSFORMS: Record<number, string> = {
  0: 'rotate(0deg)',
  1: 'rotate(90deg)',
  2: 'rotate(180deg)',
  3: 'rotate(270deg)',
};

export function HitIndicator() {
  const lastHitDirection = useGameStore((s) => s.lastHitDirection);
  const lastHitTime = useGameStore((s) => s.lastHitTime);
  const localPlayer = useGameStore((s) => s.localPlayer);

  if (lastHitDirection === null) return null;

  const elapsed = (Date.now() - lastHitTime) / 1000;
  if (elapsed > 0.6) return null;

  const opacity = Math.max(0, 1 - elapsed / 0.6);
  const cameraYaw = localPlayer.yaw ?? 0;
  const sector = resolveHitIndicatorArc(lastHitDirection, cameraYaw);

  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        width: 200,
        height: 200,
        marginLeft: -100,
        marginTop: -100,
        borderRadius: '50%',
        border: '3px solid transparent',
        borderTopColor: `rgba(255, 80, 80, ${opacity})`,
        transform: ARC_TRANSFORMS[sector] ?? 'rotate(0deg)',
        pointerEvents: 'none',
        filter: 'blur(1px)',
        zIndex: 205,
      }}
    />
  );
}
